export const UserProfilePageWidgetKey = {
  CONTACTS: 'contacts',
  CREATED: 'created',
  FINANCIAL_DETAILS: 'financial_details',
  ORAG_CLUSTER: 'orag_cluster',
  PARTNER_INFO: 'partner_info',
  PERSONAL_INFO: 'personal_info',
  POST_ADDRESS: 'post_address',
}

export const USER_PROFILE_PAGE_INHABITANT_WIDGET_LIST_ORDER = [
  UserProfilePageWidgetKey.CONTACTS,
  UserProfilePageWidgetKey.PERSONAL_INFO,
  UserProfilePageWidgetKey.POST_ADDRESS,
  UserProfilePageWidgetKey.FINANCIAL_DETAILS,
  UserProfilePageWidgetKey.PARTNER_INFO,
  UserProfilePageWidgetKey.ORAG_CLUSTER,
  UserProfilePageWidgetKey.CREATED,
]

export const USER_PROFILE_PAGE_STAFF_WIDGET_LIST_ORDER = [
  UserProfilePageWidgetKey.CONTACTS,
  UserProfilePageWidgetKey.CREATED,
]
